import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn.js';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'h-11 w-full rounded-lg border px-3 text-[15px] leading-none',
        'bg-white text-ink placeholder:text-muted-soft',
        'border-line hover:border-line-strong',
        'transition-colors duration-150',
        'focus-visible:outline-none focus-visible:border-navy focus-visible:ring-2 focus-visible:ring-navy/20',
        invalid && 'border-danger focus-visible:border-danger focus-visible:ring-danger/20',
        'disabled:bg-cream-deep/40 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});
